import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import style from './ButtonCall.module.scss';
function ButtonCall(t0) {
  const $ = _c(8);
  const {
    className,
    handleFuction,
    text
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(style.buttonCall, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== text) {
    t2 = <span>{text}</span>;
    $[2] = text;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== handleFuction || $[5] !== t1 || $[6] !== t2) {
    t3 = <button className={t1} onClick={handleFuction} data-testid="footerFormOpen">{t2}</button>;
    $[4] = handleFuction;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
export default ButtonCall;